"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BenefitDownloadDistributeResponseSchema = exports.BenefitDownloadDistributeCode = exports.BenefitDownloadInfoSchema = exports.BenefitDownloadContentSchema = exports.BenefitDownloadSubContentSchema = exports.BenefitDownloadButtonSchema = exports.BenefitDownloadImageSchema = exports.BenefitDownloadDistributeInputSchema = exports.BenefitDownloadPromotionSchema = exports.BenefitDownloadInfoInputSchema = void 0;
var zod_1 = require("zod");
exports.BenefitDownloadInfoInputSchema = zod_1.z.object({
    policyCode: zod_1.z.string(),
    requestAt: zod_1.z.string().optional(),
});
// 혜택 다운로드 프로모션 정보 스키마
exports.BenefitDownloadPromotionSchema = zod_1.z.object({
    policyCode: zod_1.z.string(),
    title: zod_1.z.string(),
    startAt: zod_1.z.string(),
    endAt: zod_1.z.string(),
    useYn: zod_1.z.boolean(),
});
// 혜택 다운로드 받기 Input 스키마
exports.BenefitDownloadDistributeInputSchema = zod_1.z.object({
    policyCode: zod_1.z.string(),
    distributorId: zod_1.z.number(),
    requestAt: zod_1.z.string().optional(),
});
exports.BenefitDownloadImageSchema = zod_1.z.object({
    section: zod_1.z.enum(['KEY_VISUAL', 'TAB_DEACTIVE', 'TAB_ACTIVE', 'LINK_IMAGE', 'GOODS_IMAGE']),
    sequence: zod_1.z.number(),
    url: zod_1.z.string(),
    altText: zod_1.z.string(),
    link: zod_1.z.string().nullish(),
});
exports.BenefitDownloadButtonSchema = zod_1.z.object({
    type: zod_1.z.literal('DOWNLOAD'),
    sequence: zod_1.z.number(),
    condition: zod_1.z.enum(['DOWNLOAD', 'SOLD_OUT']),
    altText: zod_1.z.string(),
    backgroundImage: zod_1.z.string(),
    benefitDistributorId: zod_1.z.number().nullish(),
});
exports.BenefitDownloadSubContentSchema = zod_1.z.object({
    sequence: zod_1.z.number(),
    layout: zod_1.z.enum(['BENEFIT_DOWNLOAD', 'GOODS_INFO', 'IMAGE_INFO']),
    images: zod_1.z.array(exports.BenefitDownloadImageSchema),
    buttons: zod_1.z.array(exports.BenefitDownloadButtonSchema),
});
// 럭키 박스 프로모션 내용 스키마
exports.BenefitDownloadContentSchema = zod_1.z.object({
    /**
     * ANCHOR인 경우 여러 개의 탭을 모두 보여주고 탭 클릭시 해당 탭으로 포커싱한다.
     * TAB인 경우 선택한 탭만 보여준다.
     */
    layout: zod_1.z.enum(['ANCHOR', 'TAB']),
    images: zod_1.z.array(exports.BenefitDownloadImageSchema),
    caution: zod_1.z
        .object({
        cautionText: zod_1.z.string(),
        detailCautionText: zod_1.z.string().nullish(),
    })
        .nullable(),
    share: zod_1.z
        .object({
        imageUrl: zod_1.z.string(),
        title: zod_1.z.string(),
        shareText: zod_1.z.string(),
        buttonDisplayName: zod_1.z.string(),
    })
        .nullable(),
    subContents: zod_1.z.array(exports.BenefitDownloadSubContentSchema),
});
exports.BenefitDownloadInfoSchema = zod_1.z.object({
    promotion: exports.BenefitDownloadPromotionSchema,
    content: exports.BenefitDownloadContentSchema,
    benefitDistributors: zod_1.z
        .array(zod_1.z.object({
        id: zod_1.z.number(),
        todaySoldOut: zod_1.z.boolean(),
    }))
        .nullish(),
});
exports.BenefitDownloadDistributeCode = {
    // 미로그인 시
    NEED_LOGIN: 'NEED_LOGIN',
    // 프로모션 종료 시
    NOT_PROMOTION_PERIOD: 'NOT_PROMOTION_PERIOD',
    // 선착순의 경우 운영시간 전 클릭시
    NOT_STOCK_PERIOD: 'NOT_STOCK_PERIOD',
    // 쿠폰 소진
    SOLD_OUT: 'SOLD_OUT',
    // 이미 쿠폰을 받은 경우
    ALREADY_PARTICIPATED: 'ALREADY_PARTICIPATED',
    // 회원등급 조건 미충족
    NOT_MEMBER_CLASS_CONDITION: 'NOT_MEMBER_CLASS_CONDITION',
    // 프로모션 페이지에 예전에 연결되었으나 다른 지급기로 변경되어 혜택다운로드 불가한 경우
    OUTDATED_DISTRIBUTOR: 'OUTDATED_DISTRIBUTOR',
};
exports.BenefitDownloadDistributeResponseSchema = zod_1.z.object({
    succeed: zod_1.z.boolean(),
    reason: zod_1.z
        .object({
        code: zod_1.z.enum([
            exports.BenefitDownloadDistributeCode.NEED_LOGIN,
            exports.BenefitDownloadDistributeCode.ALREADY_PARTICIPATED,
            exports.BenefitDownloadDistributeCode.NOT_PROMOTION_PERIOD,
            exports.BenefitDownloadDistributeCode.NOT_STOCK_PERIOD,
            exports.BenefitDownloadDistributeCode.SOLD_OUT,
            exports.BenefitDownloadDistributeCode.NOT_MEMBER_CLASS_CONDITION,
            exports.BenefitDownloadDistributeCode.OUTDATED_DISTRIBUTOR,
        ]),
        criteriaValue: zod_1.z.string().nullish(),
    })
        .nullish(),
});
